import { useState } from 'react';

export default function Services() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const services = [
    {
      icon: 'ri-team-line',
      number: '01',
      title: '各種コンサルティング',
      subtitle: '人事組織・財務・営業',
      description: '組織の基盤となる「人事・財務・営業」の3領域において、現場密着型のハンズオン支援を実施。人事戦略の策定、財務構造の最適化、再現性を重視した営業プロセスの構築まで、組織が自律的に成長し続けるための仕組み作りを追求します。',
      image: 'https://public.readdy.ai/ai/img_res/be2ec8f3e0cc06b09bc53ad981d22554.jpg',
      tags: ['人事戦略', '財務最適化', '営業プロセス']
    },
    {
      icon: 'ri-robot-2-line',
      number: '02',
      title: '人材開発助成金対応 AI研修',
      subtitle: '実践的なリスキリング支援',
      description: '「人材開発支援助成金」を活用した実践的なAI研修を展開。単なるツールの習得ではなく、業務の中でAIを活かすためのリスキリングを主眼に置き、人材の付加価値向上をサポートします。',
      image: 'https://readdy.ai/api/search-image?query=Modern%20AI%20training%20workshop%20with%20Japanese%20professionals%20learning%20on%20laptops%20and%20tablets%2C%20instructor%20presenting%20machine%20learning%20concepts%20on%20large%20screen%2C%20bright%20contemporary%20training%20room%20with%20technology%20focus%2C%20collaborative%20learning%20environment%20with%20navy%20and%20silver%20accents&width=800&height=600&seq=service-ai-training-001&orientation=landscape',
      tags: ['AI活用', 'リスキリング', '助成金対応']
    },
    {
      icon: 'ri-funds-line',
      number: '03',
      title: '助成金活用診断・提案',
      subtitle: '厚生労働省助成金の専門支援',
      description: '厚生労働省の助成金活用に関する高度な診断と提案。グループ内の提携社会保険労務士事務所と連携し、法令を遵守した透明性の高い資金活用と組織強化を支援します。',
      image: 'https://readdy.ai/api/search-image?query=Professional%20financial%20advisor%20explaining%20government%20subsidy%20documents%20to%20business%20owner%2C%20detailed%20paperwork%20and%20charts%20on%20desk%2C%20trustworthy%20consultation%20atmosphere%20in%20modern%20office%2C%20natural%20lighting%20with%20navy%20and%20white%20color%20scheme%2C%20Japanese%20business%20setting&width=800&height=600&seq=service-subsidy-001&orientation=landscape',
      tags: ['助成金診断', '社労士連携', '法令遵守']
    },
    {
      icon: 'ri-user-star-line',
      number: '04',
      title: 'セールス・キャリアコーチング',
      subtitle: '個人の可能性を最大化',
      description: '個人の可能性を最大化するための体系的なプログラム。自らの力で成果を出し続けるためのマインドセットとスキルの習得を伴走支援します。',
      image: 'https://readdy.ai/api/search-image?query=Professional%20business%20coach%20having%20one-on-one%20mentoring%20session%20with%20sales%20professional%2C%20encouraging%20conversation%20in%20modern%20bright%20office%2C%20growth%20mindset%20and%20career%20development%20atmosphere%2C%20natural%20lighting%20with%20navy%20and%20white%20tones%2C%20Japanese%20business%20coaching%20scene&width=800&height=600&seq=service-coaching-001&orientation=landscape',
      tags: ['マインドセット', 'スキル習得', '伴走支援']
    }
  ];

  return (
    <section id="services" className="relative py-16 md:py-32 bg-gradient-to-b from-slate-50 to-white overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-slate-200 to-transparent"></div>
        <div className="absolute top-20 right-0 w-96 h-96 bg-amber-400/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-0 w-80 h-80 bg-slate-200/50 rounded-full blur-3xl"></div>
        {/* Grid pattern */}
        <div className="absolute inset-0 opacity-[0.015]" style={{
          backgroundImage: `radial-gradient(circle at 1px 1px, #1e293b 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-5 md:px-8">
        {/* Section Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 md:mb-20 gap-4">
          <div>
            <div className="flex items-center gap-4 mb-4 md:mb-6">
              <div className="w-12 h-px bg-amber-400"></div>
              <p className="text-amber-600 text-sm font-medium tracking-widest" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                OUR SERVICES
              </p>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-3 md:mb-4" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
              事業内容
            </h2>
            <p className="text-slate-500 text-sm md:text-base max-w-xl leading-relaxed">
              人事組織・財務・営業の3領域コンサルティングから、助成金活用、AI研修、<br className="hidden md:block" />
              個人向けコーチングまで、包括的な支援を提供します。
            </p>
          </div>
          <div className="hidden lg:flex items-center gap-3">
            <span className="text-slate-400 text-sm">全4サービス</span>
            <div className="flex gap-1">
              {[...Array(4)].map((_, i) => (
                <div key={i} className={`w-8 h-1 rounded-full transition-colors ${hoveredIndex === i ? 'bg-amber-400' : 'bg-slate-200'}`}></div>
              ))}
            </div>
          </div>
        </div>

        {/* Services Grid */}
        <div className="space-y-6 md:space-y-8">
          {services.map((service, index) => (
            <div
              key={index}
              className={`group relative bg-white rounded-2xl overflow-hidden transition-all duration-500 hover:shadow-2xl hover:shadow-slate-200/50 border border-slate-100 hover:border-slate-200`}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div className={`flex flex-col lg:flex-row ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
                {/* Image */}
                <div className="lg:w-1/2 relative overflow-hidden">
                  <div className="w-full h-52 sm:h-64 lg:h-[420px]">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 via-slate-900/20 to-transparent"></div>
                  
                  {/* Number overlay */}
                  <div className="absolute top-4 left-4 md:top-6 md:left-6">
                    <span className="text-5xl md:text-7xl font-bold text-white/10" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                      {service.number}
                    </span>
                  </div>
                  
                  {/* Tags */}
                  <div className="absolute bottom-4 left-4 md:bottom-6 md:left-6 flex flex-wrap gap-1.5 md:gap-2">
                    {service.tags.map((tag, tagIndex) => (
                      <span key={tagIndex} className="px-2.5 py-1 bg-white/20 backdrop-blur-sm text-white text-xs rounded-full border border-white/20">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Content */}
                <div className="lg:w-1/2 p-6 sm:p-8 lg:p-14 flex flex-col justify-center">
                  <div className="flex items-center gap-4 mb-4 md:mb-6">
                    <div className="w-12 h-12 md:w-14 md:h-14 bg-gradient-to-br from-slate-100 to-slate-50 rounded-xl flex items-center justify-center shadow-sm group-hover:shadow-md transition-shadow border border-slate-100">
                      <i className={`${service.icon} text-xl md:text-2xl text-slate-700`}></i>
                    </div>
                    <div className="w-12 h-px bg-amber-400 group-hover:w-20 transition-all duration-500"></div>
                  </div>
                  
                  <p className="text-amber-600 text-xs font-semibold tracking-wider mb-1.5 md:mb-2">{service.subtitle}</p>
                  <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-slate-900 mb-4 md:mb-6" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                    {service.title}
                  </h3>
                  
                  <p className="text-slate-600 leading-relaxed text-sm md:text-base">
                    {service.description}
                  </p>
                </div>
              </div>

              {/* Hover accent line */}
              <div className={`absolute top-0 ${index % 2 === 1 ? 'right-0' : 'left-0'} w-1 h-0 bg-gradient-to-b from-amber-400 to-amber-500 group-hover:h-full transition-all duration-500`}></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
